import clsx from "clsx";

export const Gradient = ({ children, className }) => {
  return (
    <div className={clsx(className, "relative")}>
      <div
        className="absolute z-0 pointer-events-none left-0 top-0 mt-96 origin-top-left translate-y-20 -rotate-0 transform-gpu opacity-15 blur-3xl sm:left-1/4 sm:-ml-96 sm:-mt-10 sm:translate-y-0 sm:rotate-0 sm:transform-gpu sm:opacity-15"
        aria-hidden="true"
      >
        <div
          className="aspect-[1154/678] w-[72.125rem] bg-gradient-to-br from-yellow to-pink"
          style={{
            clipPath:
              "polygon(100% 38.5%, 82.6% 100%, 60.2% 37.7%, 52.4% 32.1%, 47.5% 41.8%, 45.2% 65.6%, 27.5% 23.4%, 0.1% 35.3%, 17.9% 0%, 27.7% 23.4%, 76.2% 2.5%, 74.2% 56%, 100% 38.5%)",
          }}
        />
      </div>
      {children}
    </div>
  );
};
